import { LOADING_UI } from "../types";
import { db } from "../../firebase/firebase";
import logAnalyticsEvent from "../../utils/logAnalyticsEvent";
import { getOrganizationRef } from "./utils";

export const addNewDeviceGroup = ({ name, registrationCode, selectedBundleKeys, kioskAppKey, organizationKey, approvedAppsKeys }) => dispatch => {
    dispatch({ type: LOADING_UI, payload: true });
    const contentBundleRefs = [];
    selectedBundleKeys.forEach(s => contentBundleRefs.push(db.doc("contentBundles/" + s)));
    const kioskAppRef = kioskAppKey != "NONE" ? db.doc("apps/" + kioskAppKey) : null;
    const approvedApps = [];
    approvedAppsKeys.forEach(s => approvedApps.push(db.doc("apps/" + s)));

    db.collection("deviceGroups").add({
        name,
        registrationCode,
        contentBundleRefs,
        organizationRef: getOrganizationRef(organizationKey),
        kioskAppRef,
        approvedApps
    });
    logAnalyticsEvent("add_device_group", { name, kioskMode: kioskAppKey != "NONE" });
};

export const saveDeviceGroup = ({ deviceGroupId, changes }) => {
    if (deviceGroupId) {
        db.collection("deviceGroups")
            .doc(deviceGroupId)
            .set(changes, { merge: true });
    } else {
        db.collection("deviceGroups").add(changes);
    }
}


export const editDeviceGroup = ({ key, name, registrationCode, selectedBundleKeys, kioskAppKey, organizationKey, approvedAppsKeys, hiddenAppKeys, firstTimeUseFilePaths = [], firstTimeUseAppKey }) => dispatch => {
    const contentBundleRefs = [];
    selectedBundleKeys.forEach(s => contentBundleRefs.push(db.doc("contentBundles/" + s)));
    const kioskAppRef = kioskAppKey != "NONE" ? db.doc("apps/" + kioskAppKey) : null;
    const firstTimeUseAppRef = firstTimeUseAppKey != "NONE" ? db.doc("apps/" + firstTimeUseAppKey) : null;
    const approvedApps = [];
    approvedAppsKeys.forEach(s => approvedApps.push(db.doc("apps/" + s)));
    const hiddenAppRefs = [];
    hiddenAppKeys.forEach(s => hiddenAppRefs.push(db.doc("apps/" + s)));

    firstTimeUseFilePaths = firstTimeUseFilePaths.filter(function (el) {
        return el.length; // remove empty values
    });

    db.collection("deviceGroups")
        .doc(key)
        .update({
            name,
            registrationCode,
            contentBundleRefs,
            kioskAppRef,
            organizationRef: getOrganizationRef(organizationKey),
            approvedApps,
            hiddenAppRefs,
            firstTimeUseFilePaths,
            firstTimeUseAppRef,
        });
    logAnalyticsEvent("edit_device_group", { name, kioskMode: kioskAppKey != "NONE" });
};

export const editDeviceGroupKioskApp = ({ key, kioskAppKey }) => dispatch => {
    dispatch({ type: LOADING_UI, payload: true });
    const kioskAppRef = kioskAppKey != "NONE" ? db.doc("apps/" + kioskAppKey) : null;

    db.collection("deviceGroups")
        .doc(key)
        .update({
            kioskAppRef,
        });
    logAnalyticsEvent("edit_device_group", { key, kioskMode: kioskAppKey != "NONE" });
};

export const deleteDeviceGroup = groupKey => dispatch => {
    dispatch({ type: LOADING_UI, payload: true });
    db.collection("deviceGroups")
        .doc(groupKey)
        .delete();
};
